import { BankAccountsList } from "../../../../BankAccounts"

export default function OrganizationBankAccountsSettingsPage() {
	return <BankAccountsList />
}
